// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tagItem {
  background: rgb(225 234 245);
  transition: background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.tagItem--clickable {
  cursor: pointer;
}

.tagItem--clickable:hover {
  background: rgb(208 224 255);
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.25);
  transform: translateY(+1px);
}

.tagItem--clickable:active {
  transform: translateY(0);
}

.tagItem--deleted {
  background: rgb(245 225 226) !important;
}

.tagItem--deleted.tagItem--clickable:hover {
  background: rgb(245 225 226) !important;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.25);
}

`, "",{"version":3,"sources":["webpack://./src/ui/css/TagsComponent.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,oFAAoF;AACtF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C","sourcesContent":[".tagItem {\n  background: rgb(225 234 245);\n  transition: background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.tagItem--clickable {\n  cursor: pointer;\n}\n\n.tagItem--clickable:hover {\n  background: rgb(208 224 255);\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.25);\n  transform: translateY(+1px);\n}\n\n.tagItem--clickable:active {\n  transform: translateY(0);\n}\n\n.tagItem--deleted {\n  background: rgb(245 225 226) !important;\n}\n\n.tagItem--deleted.tagItem--clickable:hover {\n  background: rgb(245 225 226) !important;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.25);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
